import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import CustomizePage from "../pages/customize/page";
import ShopPage from "../pages/shop/page";
import BestSellersPage from "../pages/best-sellers/page";
import AboutPage from "../pages/about/page";
import ContactPage from "../pages/contact/page";
import FAQPage from "../pages/faq/page";
import ShippingPage from "../pages/shipping/page";
import ReturnsPage from "../pages/returns/page";
import PrivacyPage from "../pages/privacy/page";
import TermsPage from "../pages/terms/page";

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/customize",
    element: <CustomizePage />,
  },
  {
    path: "/shop",
    element: <ShopPage />,
  },
  {
    path: "/best-sellers",
    element: <BestSellersPage />,
  },
  {
    path: "/about",
    element: <AboutPage />,
  },
  {
    path: "/contact",
    element: <ContactPage />,
  },
  {
    path: "/faq",
    element: <FAQPage />,
  },
  {
    path: "/shipping",
    element: <ShippingPage />,
  },
  {
    path: "/returns",
    element: <ReturnsPage />,
  },
  {
    path: "/privacy",
    element: <PrivacyPage />,
  },
  {
    path: "/terms",
    element: <TermsPage />,
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;